import * as countries from 'i18n-iso-countries';
import enNames from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enNames);

export const getCountryLabel = (code: string) => {
  const name = countries.getName(code, 'en') || 'Unknown country code';
  return name;
};

export const countryOptions = () => {
  const alph2ToName = countries.getNames('en', { select: 'official'});
  const options = Object.entries(alph2ToName).map(([alpha2, name]) => {
    return {
      alias: countries.alpha2ToAlpha3(alpha2),
      label: name,
    };
  });
  return options;
};

export const getCountryCode3ByName = (name: string): string => {
  if (name.toLowerCase() === 'united states') {
    return 'USA';
  }
  const guessedName = countries.getName(name, 'en');
  const formattedName = guessedName || name;
  const countryCode3 = countries.getAlpha3Code(formattedName, 'en');
  return countryCode3 || name;
};

export const euCountryCode = () => {
  return [
    'AUT',
    'BEL',
    'BGR',
    'HRV',
    'CYP',
    'CZE',
    'DNK',
    'EST',
    'FIN',
    'FRA',
    'DEU',
    'GRC',
    'HUN',
    'IRL',
    'ITA',
    'LVA',
    'LTU',
    'LUX',
    'MLT',
    'NLD',
    'POL',
    'PRT',
    'ROU',
    'SVK',
    'SVN',
    'ESP',
    'SWE',
  ];
};

export const getZoneFromCountryCode = (countryCode: string): string => {
  // zone1: UK, Ireland, EU, USA, Canada, Mexico
  // zone2: rest of the world
  const upperCode = countryCode.toString().toUpperCase();
  const euList = [
    'AUT',
    'BEL',
    'BGR',
    'HRV',
    'CYP',
    'CZE',
    'DNK',
    'EST',
    'FIN',
    'FRA',
    'DEU',
    'GRC',
    'HUN',
    'IRL',
    'ITA',
    'LVA',
    'LTU',
    'LUX',
    'MLT',
    'NLD',
    'POL',
    'PRT',
    'ROU',
    'SVK',
    'SVN',
    'ESP',
    'SWE',
  ];
  const zone1 = ['GBR', 'IRL', 'USA', 'CAN', 'MEX'];
  if (euList.includes(upperCode) || zone1.includes(upperCode)) {
    return 'Zone 1';
  } else {
    return 'Zone 2';
  }
};
